module.exports = __webpack_public_path__ + "img/20200507_135953.8c5a50b1.jpg";